import { gql } from "@apollo/client";

// The visualization link is stored as a plain node attribute whose id ends in
// ':visualizationUrl' (e.g. urn:installed-base-node-attribute:87459:visualizationUrl);
// its property is null, so matching happens on the id suffix (see getVisualizationUrl).
export const SystemVisualizationUrl = gql`
    query SystemVisualizationUrl ($id: ID!) {
        system (id: $id) {
            id
            attributeList {
                attributes {
                    id
                    value
                    property {
                        id
                        alias
                    }
                }
            }
        }
    }
`;
